import { error, money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const FeeBasedTransferMaximumQuery = gql`
  query FeeBasedTransferMaximum($input: TransferOptionsInput) {
    transferOptions(input: $input) {
      __typename
      ... on TransferOptions {
        maxTransfer {
          ...money
        }
      }
      ... on TransferNotPossibleError {
        ...error
      }
    }
  }
  ${error}
  ${money}
`;

export default FeeBasedTransferMaximumQuery;
